import Collapsible from 'react-native-collapsible';
import { FC } from 'react';
import { FontAwesome } from '@expo/vector-icons';
import { ParagraphLBold, ParagraphMRegular } from '../../../config/designSystem/typography';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { Track } from './PresentContentAudio';
import { isWeb } from '../../../config/designSystem/Layout';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';

interface TranscriptProps {
  track: Track;
  sessionStepId?: string;
  isCollapsed?: boolean;
  setIsCollapsed: (value: boolean) => void;
  labels?: {
    TRANSCRIPTION?: string
  }
}

const _Transcript: FC<TranscriptProps> = ({
  track,
  sessionStepId,
  isCollapsed,
  setIsCollapsed,
  labels
}) => {
  const ViewComponent = isWeb ? ScrollView : View;
  return (
    <ViewComponent style={{marginTop: 15}}>
      <TouchableOpacity
        onPress={() => {
          logAmplitude('Transcript Opened', {
            contentId: track?._id,
            contentName: track?.title,
            sessionStepId: sessionStepId,
          });

          setIsCollapsed(!isCollapsed);
        }}
        style={{
          backgroundColor: '#F7F7F7',
          paddingHorizontal: 15,
          paddingVertical: 10,
          borderRadius: 6,
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginVertical: 5,
        }}
      >
        <ParagraphLBold selectable={false}>
          {labels?.TRANSCRIPTION ? labels.TRANSCRIPTION : 'Transcription'}
        </ParagraphLBold>
        <FontAwesome name={isCollapsed ? 'chevron-down' : 'chevron-up'} />
      </TouchableOpacity>
      <Collapsible collapsed={isCollapsed} collapsedHeight={0}>
        <View style={{ marginLeft: 5 }}>
          <ParagraphMRegular selectable={true}>
            {track?.transcript}
          </ParagraphMRegular>
        </View>
      </Collapsible>
    </ViewComponent>
  );
};

export const Transcript = observer(_Transcript);